module.exports = __webpack_public_path__ + "img/u254.23fc05f6.svg";